import { render, staticRenderFns } from "./CreateCSOClient.vue?vue&type=template&id=3b866fdc"
import script from "./CreateCSOClient.vue?vue&type=script&lang=js"
export * from "./CreateCSOClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports